<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划转移单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="year" label="转移单据号">
              <el-input v-model="conditions.shift_id" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer2" label="老客户">
              <el-input v-model="conditions.customer2" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="change_name" label="老客户名称">
              <el-input
                :value="conditions.change_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="year" label="单据类型">
              <el-input value="销售计划转移单" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer1" label="新客户">
              <el-input v-model="conditions.customer1" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="create_name" label="新客户名称">
              <el-input
                :value="conditions.create_name"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="gjahr" label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                value-format="yyyy"
                type="year"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select v-model="conditions.porder_status" placeholder="请输入">
                <el-option
                  v-for="item in selectDataOptions['A0045']"
                  :key="item.id"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="4"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { apiSalePlanTransformDetail } from '@/api/sap/sale-plan'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
export default {
  name: 'SalePlanTransfer',

  data() {
    return {
      conditions: {
        gjahr: '',
        remark: '',
        change_name: '',
        customer1: '',
        create_name: '',
        customer2: '',
        porder_status: 'E001',
        datum: '',
        uname: '',
        shift_id: ''
      },
      selectDataOptions: {}
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0045')
    this.getDetail()
  },

  methods: {
    async getDetail() {
      const iv_shift_id = this.$route.query.id
      const res = await apiSalePlanTransformDetail({ iv_shift_id })
      Object.assign(this.conditions, res.head)
      this.conditions.porder_status = res.head.status
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanTransferCheck.vue